"use client"
import React from "react";
import { AeroIcon } from "@/utlility/icons";
import { colors } from "@/app/Colors";
import Link from "next/link";

const CustomButton = ({ text, className = "", srText = "", disabled, href, ...rest }) => {
  const isLink = !!href;

  const commonClassName = `comman-button d-inline-flex align-items-center wrap-nowrap ${className}`;
  const ariaLabel = rest["aria-label"] ?? text;

  const content = (
    <>
      {srText && (
        <span className="visually-hidden">
          {srText}
        </span>
      )}
      <span className="fw-medium text-part">
        {text}
      </span>

      <i className="icon" aria-hidden="true">
        <AeroIcon color={colors["--text-primary"]} />
      </i>
    </>
  );

  if (isLink) {
    return (
      <Link
        href={href}
        className={commonClassName}
        aria-label={ariaLabel}
        {...rest}
      >
        {content}
      </Link>
    );
  }

  return (
    <button
      type={rest.type || "button"}
      className={commonClassName}
      disabled={disabled}
      aria-label={ariaLabel}
      {...rest}
    >
      {content}
    </button>
  );
};

export default CustomButton;

